import React from "react";

/**
 * TableStatusBar – Clean, lightweight status bar showing record count,
 * indicating seamless continuous loading and arrow key support.
 */
function TableStatusBar({
  visibleCount,
  totalRows,
  hasMore,
  onLoadAll,
  onLoadMore,
}) {
  if (!totalRows || totalRows === 0) return null;

  const currentCount = Math.min(visibleCount || totalRows, totalRows);

  return (
    <div className="flex flex-wrap items-center justify-between px-3 py-1.5 bg-white border-t border-slate-200 text-[11px] font-Inter font-semibold text-slate-600 shrink-0 gap-2 select-none">
      <div className="flex items-center gap-2">
        <span>
          Showing <span className="text-[#1e73be] font-bold">{currentCount}</span> of{" "}
          <span className="text-slate-800 font-bold">{totalRows}</span> records
        </span>
        {hasMore && (
          <span className="text-[10px] text-slate-400 font-normal">
            • Scroll down or press <kbd className="px-1 py-0.2 bg-slate-100 border border-slate-300 rounded text-[9px] font-mono">↓</kbd> to load more
          </span>
        )}
      </div>

      {hasMore && (
        <div className="flex items-center gap-1.5">
          {onLoadMore && (
            <button
              type="button"
              onClick={onLoadMore}
              className="px-2 py-0.5 rounded border border-slate-200 bg-white hover:bg-slate-50 text-[10px] font-bold text-slate-700 cursor-pointer transition-colors"
            >
              Load +100 more
            </button>
          )}
          {onLoadAll && totalRows <= 5000 && (
            <button
              type="button"
              onClick={onLoadAll}
              className="px-2 py-0.5 rounded border border-[#1e73be] bg-blue-50 text-[#1e73be] hover:bg-blue-100 text-[10px] font-bold cursor-pointer transition-colors"
            >
              Load all ({totalRows})
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export default TableStatusBar;
